export default {
  placeholder: 'Select steel grade group',
};
